import React, { createContext, useState, useEffect } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [logo, setLogo] = useState('/assets/b.png');
  const [logoSize, setLogoSize] = useState('100px');

  useEffect(() => {
    setLogo(isDarkMode ? '/icons/psg-logo-new-dark.png' : '/icons/psg-new-light.png'); 
    setLogoSize(isDarkMode ? '100px' : '100px'); 
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.style.setProperty('--fg-color', 'var(--light-color)');
      document.documentElement.style.setProperty('--bg-color', 'var(--dark-color)');
      document.documentElement.style.setProperty('--tertiary-color', 'var(--dark-tertiary-color)');
      document.documentElement.style.setProperty('--quart-color', 'var(--dark-quart-color)');
      document.documentElement.style.setProperty('--pent-color', 'var(--dark-pent-color)');
    } else {
      document.documentElement.style.setProperty('--fg-color', 'var(--dark-color)');
      document.documentElement.style.setProperty('--bg-color', 'var(--light-color)');
      document.documentElement.style.setProperty('--tertiary-color', 'var(--light-tertiary-color)');
      document.documentElement.style.setProperty('--quart-color', 'var(--light-quart-color)');
      document.documentElement.style.setProperty('--pent-color', 'var(--light-pent-color)');
    }
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleDarkMode, logo, logoSize }}>
      {children}
    </ThemeContext.Provider>
  );
};
